import React from 'react';
import { initialTickets } from '../data/mockData';
import { cn } from '../lib/utils';
import SafeIcon from '../components/common/SafeIcon';
import { FiAlertOctagon } from 'react-icons/fi';

export default function EscalationBoard() {
  const urgentTickets = initialTickets.filter(t => t.priority === 'urgent');

  return (
    <div className="flex-1 p-8 bg-navy-900 overflow-y-auto">
      <div className="flex items-center gap-3 mb-8">
        <div className="p-3 bg-priority-red/20 rounded-xl">
          <SafeIcon icon={FiAlertOctagon} className="text-priority-red text-2xl" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-white">Escalation Board</h1>
          <p className="text-slate-400 text-sm">Critical issues requiring immediate attention</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Kanban Column */}
        <div className="bg-navy-800/50 rounded-2xl p-4 border border-navy-700 h-[calc(100vh-12rem)]">
          <h3 className="text-priority-red font-semibold mb-4 uppercase tracking-wider text-sm flex justify-between items-center">
            P1 - System Outage
            <span className="bg-priority-red/20 text-priority-red px-2 py-0.5 rounded text-xs">1</span>
          </h3>
          
          <div className="space-y-4">
            {urgentTickets.map(ticket => (
              <div key={ticket.id} className="glass-panel p-5 rounded-xl border border-priority-red/30 glow-red">
                <div className="flex justify-between items-start mb-3">
                  <span className="text-xs font-mono text-priority-red">{ticket.id}</span>
                  <span className="text-[10px] bg-red-500/20 text-red-300 px-2 py-1 rounded">SLA: 45m</span>
                </div>
                <h4 className="text-white font-medium mb-3">{ticket.subject}</h4>
                <div className="flex items-center gap-3 text-sm text-slate-400">
                  <img src={ticket.customer.avatar} className="w-6 h-6 rounded-full" alt="avatar" />
                  <span>{ticket.customer.company}</span>
                </div>
                <button className="w-full mt-4 py-2 bg-priority-red text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-colors">
                  Take Ownership
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Empty Columns for layout */}
        <div className="bg-navy-800/30 rounded-2xl p-4 border border-navy-700/50 h-[calc(100vh-12rem)] border-dashed">
          <h3 className="text-orange-400 font-semibold mb-4 uppercase tracking-wider text-sm">P2 - Degraded Performance</h3>
          <div className="h-full flex items-center justify-center text-slate-600 text-sm">No active escalations</div>
        </div>
        
        <div className="bg-navy-800/30 rounded-2xl p-4 border border-navy-700/50 h-[calc(100vh-12rem)] border-dashed">
          <h3 className="text-yellow-400 font-semibold mb-4 uppercase tracking-wider text-sm">P3 - VIP Blocking</h3>
          <div className="h-full flex items-center justify-center text-slate-600 text-sm">No active escalations</div>
        </div>
      </div>
    </div>
  );
}